<div cdkDropListGroup class="draggable-group">
  @if (_draggableLists != null) {
    @for (list of _draggableLists; track list) {
      <div class="draggable-list">
        <div class="draggable-list__header">
          <h4 class="name">{{ list?.header }}</h4>
          <h6 class="description">{{ list?.description }}</h6>
        </div>
        <div
          cdkDropList
          class="draggable-list__drop-list"
          [id]="list?.id != null ? list.id : ''"
          [ngClass]="list?.style?.list"
          [cdkDropListData]="list?.elements"
          [cdkDropListLockAxis]="list?.lockAxis"
          [cdkDropListSortingDisabled]="list?.sorting?.disabled"
          (cdkDropListDropped)="onElementDrop($event)"
          >
          @for (item of list?.elements; track item) {
            <div
              cdkDrag
              class="draggable-item"
              [ngClass]="list?.style?.item"
              [cdkDragDisabled]="item.isDisabled"
              >
              @if (item.isDisabled) {
                <mat-icon>lock</mat-icon>
              } @else {
                <mat-icon svgIcon="alt-handle-icon"></mat-icon>
              }
              <p>{{ item.value | uppercase }}</p>
            </div>
          }
        </div>
      </div>
    }
  } @else {
    <h3>Missing Configurations</h3>
  }
</div>
